class Lineitem {
  constructor(data) {
    this._data = data
  }

  getStatus() {
    if (!this._data) {
      return 'pending'
    }

    // todo get status
    return this._data.state
  }

  getId() {
    if (!this._data) {
      return '123456'
    }

    return this._data.extLineItemId
  }

  getSurveyTestingNotes() {
    if (!this._data) {
      return 'N/A';
    }
    return this._data.surveyTestingNotes
  }

  getLineItemUUID() {
    if (!this._data) {
      return '123456'
    }

    return this._data.lineItemUUID
  }

  getProjectUUID() {
    if (!this._data) {
      return '123456'
    }

    return this._data.projectUUID
  }

  getTitle(){
    if (!this._data) return ''
    return this._data.title
  }

  getState(){
    if (!this._data) {
      return ''
    }

    return this._data.state
  }

  getQaState(){
    if (!this._data) {
      return ''
    }

    return this._data.qaState
  }

  getTestLink() {
    if (!this._data) {
      return 'https://peanutlabs.com'
    }

    return this._data.surveyTestURL
  }

  getCountryCode() {
    if (!this._data) {
      return 'N/A'
    }

    return this._data.countryISOCode
  }

  getLanguageCode() {
    if (!this._data) {
      return 'N/A'
    }

    return this._data.languageISOCode
  }

  getLOI() {
    if (!this._data) {
      return 'N/A'
    }

    return this._data.lengthOfInterview
  }

  getIncidenceRate() {
    if (!this._data) {
      return 'N/A'
    }

    return this._data.indicativeIncidence
  }

  getCPI() {
    if (!this._data) {
      return 'N/A'
    }

    return 'N/A'
  }

  setAssignedUser(assignedTo) {
    this._data.user = {
      ...this._data.user,
      assignedTo
    }
  }

  getStateReason() {
    if (!this._data) return {}
    return this._data.stateReason
  }

  getAssignedUser() {
    if(!this._data) return {}
    return this._data.user.assignedTo
  }

  getAssignedDate() {
    if(!this._data){
      return {}
    }

    return this._data.user.assignedAt
  }
  
  getCreatedAt() {
    if(!this._data){
      return ""
    }

    return this._data.createdAt
  }

  getQuotaPlan() {
    if(!this._data){
      return {}
    }

    return this._data["quotaPlan"]
  }

  getQuotaGroups() {
    if(!this._data){
      return {}
    }

    return this._data["quotaPlan"].quotaGroups
  }

  getQuotaFilters() {
    if(!this._data){
      return {}
    }

    return this._data["quotaPlan"].filters
  }

  getQuotaAttributesIds() {
    if(!this._data){
      return []
    }
    let ids = []
    const quotaGroups = this.getQuotaGroups()
    const quotaFilters = this.getQuotaFilters()
    if(quotaGroups && quotaGroups.length) {
      quotaGroups.forEach(group => {
        group.quotaCells.forEach(cell => {
          cell.quotaNodes.forEach(node => {
            if(ids.indexOf(node.attributeId) < 0) {
              ids.push(node.attributeId)
            }
          })
        })
      })
    }
    
    if(quotaFilters && quotaFilters.length) {
      quotaFilters.forEach(filter => {
        ids.push(filter.attributeId)
      })
    }
    return ids
  }
}

export default Lineitem